export enum BRAND_ACTIONS {
	LOAD = '[Brand] Load Brands',
	LOAD_CALL_SOURCES = '[Brand] Load Call Sources',
}

export namespace BrandAction {
	export class LoadBrands {
		static readonly type = BRAND_ACTIONS.LOAD
	}

	export class LoadCallSources {
		static readonly type = BRAND_ACTIONS.LOAD_CALL_SOURCES
	}
}
